// Cloudflare Web Analytics (owner decision G6): cookieless, no banner. Loaded after the map so it
// never competes with the poster for bandwidth. The token is public by design (it's in every page).

export function loadAnalytics(token: string | undefined = import.meta.env.VITE_CF_BEACON_TOKEN): void {
  if (!token) return;
  const s = document.createElement("script");
  s.defer = true;
  s.src = "https://static.cloudflareinsights.com/beacon.min.js";
  s.dataset.cfBeacon = JSON.stringify({ token, spa: true });
  document.head.append(s);
}
